module.exports = __webpack_public_path__ + "img/mask-img.9053eead.png";